<template lang="html">
  <v-dialog
    v-model="ErrorDialog"
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card :style="stylechat">
      <v-card-title primary-title style="justify-content: center;">
        {{ErrorDialogDetail.title}}
      </v-card-title>
      <v-card-text style="text-align: center;">
        <span class="fontsize-span">{{ErrorDialogDetail.text}}</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row justify="center" align="center">
          <v-col cols="6" align="center">
            <v-btn class="btn-color-confirm" block text @click="closeDialog()">{{$t('AnswerQuestion.ok')}}</v-btn>
          </v-col>
          <!-- <v-divider vertical class="mt-1"></v-divider>
          <v-col cols="6" align="center">
            <v-btn class="btn-color-cancel" block text @click="closeDialog()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          </v-col> -->
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    ErrorDialog: Boolean,
    ErrorDialogDetail: {}
  },
  data () {
    return {
      tokenbot: '',
      password: '',
      stylechat: {
        "--ErrorDialog-HeaderColor": "white",
        "--ErrorDialog-TabBackground": "white",
        "--ErrorDialog-Icon": "gray",
        "--ErrorDialog-IconActive": "#2662ae",
        "--ErrorDialog-Background": "white",
        "--ErrorDialog-FontSize": "18px",
        "--ErrorDialog-FontColor": "black",
        "--ErrorDialog-FontSize-Status": "16px",
        "--ErrorDialog-FontSize-Text": "17px",
        "--ErrorDialog-Color-Text": "#727272",
        "--ErrorDialog-FontColor-Status": "grey",
        "--ErrorDialog-Background-Input": "#E2E1E3",
        "--ErrorDialog-Color-Button": "#EFF2FE",
        "--ErrorDialog-FontColor-Button": "#2662ae",
        "--ErrorDialog-FontColor-Button-Cancel": "#cb1002"
      },
    }
  },
  watch: {
    ErrorDialog () {
      // console.log(this.ErrorDialog)
      // console.log(this.ErrorDialogDetail)
      if (this.ErrorDialog) {
        // this.tokenbot = this.ErrorDialogDetail.user.tokenuser
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeAlertDialog', { type: 'err', value: false })
    },
    // confirmData () {
    //   this.$emit('emitWarning', this.ErrorDialogDetail)
    // }
  }
}
</script>

<style lang="css" scoped>
.fontsize-span {
  font-size: var(--ErrorDialog-FontSize-Text) !important;
  color: var(--ErrorDialog-Color-Text) !important;
}
.btn-color-confirm {
  color: var(--ErrorDialog-FontColor-Button) !important;
  text-transform: none !important;
  font-weight: 600;
  font-size: var(--ErrorDialog-FontSize) !important;
}
.btn-color-cancel {
  color: var(--ErrorDialog-FontColor-Button-Cancel) !important;
  text-transform: none !important;
  font-size: var(--ErrorDialog-FontSize) !important;
}
>>>.v-dialog {
  border-radius: 15px;
  margin: 24px;
  overflow: hidden;
  pointer-events: auto;
  width: 100%;
  z-index: inherit;
  outline: none;
}
>>>.v-input__slot {
  background-color: var(--ErrorDialog-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
</style>
